import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import LabsFlock from '../components/LabsFlock';
import { PlaceholderImage } from '../components/PlaceholderMedia';
import labsData from '../data/labs.json';

const Labs = () => {
  return (
    <main className="main-wrapper">
      <div className="main-wrapper-left">
        <div className="project-hero-image-wrapper lab-hero">
          <div className="card-corner-bottom-right">
            <div className="text-meta">Labs</div>
            <div className="corner-bottom-right top w-embed">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
              </svg>
            </div>
            <div className="corner-bottom-right bottom w-embed">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
              </svg>
            </div>
          </div>
          <LabsFlock />
        </div>
      </div>
      <div className="main-wrapper-right">
        <section className="section-work-projects">
          <div className="page-heading">
            <h1 className="heading-style-h1">Labs</h1>
            <div className="page-heading-bottom">
              <div className="max-width-medium">
                <div className="text-size-medium">
                  Experiments, prototypes, and playable sketches - small ideas explored in the open. Some are works in progress and locked behind a password.
                </div>
              </div>
            </div>
          </div>
          <div className="labs-grid">
            {labsData.map((lab) => (
              <div key={lab.slug} className="project-preview">
                <Link to={`/labs/${lab.slug}`} className="project-preview-image-wrapper w-inline-block">
                  <div className="view-button-wrapper">
                    <div className="view-button">
                      <div className="view-button-icon w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                          <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  {lab.passwordHash ? (
                    <div className="lab-lock-badge" title="Password protected">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                        <path d="M208,82H174V56a46,46,0,0,0-92,0V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82ZM94,56a34,34,0,0,1,68,0V82H94ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z"></path>
                      </svg>
                    </div>
                  ) : null}
                  <div className="project-preview-content">
                    <h3 className="text-meta">{lab.title}</h3>
                    <div className="corner-top-left top w-embed">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                      </svg>
                    </div>
                    <div className="corner-top-left bottom w-embed">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                      </svg>
                    </div>
                  </div>
                  {lab.passwordHash ? (
                    <div className="lab-poster-locked"></div>
                  ) : (
                    <PlaceholderImage className="project-preview-image" src={lab.poster} alt={lab.title} loading="lazy" />
                  )}
                </Link>
              </div>
            ))}
          </div>
        </section>
        <Footer />
      </div>
    </main>
  );
};

export default Labs;
